module.exports = __webpack_public_path__ + "static/media/advanced.83d377bd.png";